export const APP_URL = "https://spotter-gym-two.vercel.app/";
export const APP_VERSION = "2.2";
export const WHATS_NEW_TITLE = "Sets and steady progress";
export const WHATS_NEW_DATE = "18 Oct 2026";
export const WHATS_NEW = [
  ["Sets", "Back to a row for every set (kg, reps, ✓). ✕ removes just that set, + Add set adds one."],
  ["Breaks", "Tick your last set and a break starts before the next machine (1-2 min, longer if you change area). +30s or Skip."],
  ["Getting stronger", "Finish your sets and next time Spotter asks you to go up: Go up or Stay."],
  ["Starting weights", "Starts light from your bodyweight and height (add height in Settings)."],
  ["Plan", "Change the number of sets for each exercise in your weekly plan again."],
];
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) {
    window.location.href = `/#${id}`;
    return;
  }
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const EASE = [0.22, 1, 0.36, 1];

export const goToTesterSignup = () => {
  window.dispatchEvent(new Event("spotter:pick-tester"));
  scrollToId("waitlist");
};
